module.exports = __webpack_public_path__ + "img/logo.1f4f2c70.png";